import React from "react";
import { Card } from "react-bootstrap";
import "./Portfolio.css";
import app_store from "../images/app_store.png";
import play_store from "../images/play_store.png";
import { openURL } from "../common/common";

const PortfolioCardView = ({ name, description, img, android, ios, tech }) => {
 

  return (
    <Card className="w-100 mb-4 portfolio-card">
      <Card.Img
        variant="top"
        src={img}
        className="img-fluid"
        style={{ objectFit: "cover", maxHeight: 200 }}
      />
      <Card.Body>
        <Card.Title className="h5">{name}</Card.Title>
        <Card.Text>{description}</Card.Text>
        <div className="tech-list mb-2">
          {tech.map((item) => (
            <span className="tech-item" key={item}>
              {item}
            </span>
          ))}
        </div>
        <div className="store-links">
          {android && (
            <img
              src={play_store}
              className="store-icon"
              onClick={() => openURL(android)}
            />
          )}
          {ios && (
            <img
              src={app_store}
              className="store-icon"
              onClick={() => openURL(ios)}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default PortfolioCardView;
